export default "__VITE_ASSET__Fw2neXI2__"